import CopyIcon from '../../../../../assets/CopyIcon.svg?react';
import { CopyButton } from '../../../../../components/CopyButton/CopyButton';
import { copy } from '../../../../../components/util/copy';
import { useSellerHandle } from '../../../../../hooks/useSellerHandle.hook';
import { getUrlFromPath } from '../../../../../utils/getUrlFromPath';

export const CopyLandingLink = () => {
  const { sellerHandle } = useSellerHandle();
  const url = getUrlFromPath(`/pay/spending-account/${sellerHandle}`)!;
  return (
    <div className="relative mt-l flex h-3xl">
      <input
        className="box-border h-full w-full rounded-l-s rounded-r-none border border-r-0 border-structure-95 pl-l font-sans text-m font-med text-denim-25"
        type="text"
        readOnly={true}
        value={url}
        data-testid="copyInputValue"
      />
      <CopyButton
        className="rounded-l-none rounded-r-s border border-l-0 border-structure-95 bg-white p-s"
        aria-label="copy link"
        onClick={() => copy(url)}
        title="Copy Spending Limit Landing link"
      >
        <CopyIcon />
      </CopyButton>
    </div>
  );
};
